module.exports = __webpack_public_path__ + "static/media/arduino-logo.9d736f97.png";